/* eslint indent: 0 */

import 'tipsy/src/stylesheets/tipsy.css';
import './media_library.asset_list_item.less';
import './media_library.asset_grid_item.less';

import 'tipsy/src/javascripts/jquery.tipsy.js';

import _extend from 'lodash/extend';

import AbstractItem from './media_library.abstract_item.js';
import { defaultDatetimeFormat } from 'zoomforth_zfutils/datetime_formatting.js';
import { getDisplayNameForAssetType } from 'zoomforth_media_library/lib/assets.js';

import assetListItemTemplate from './media_library.asset_list_item.tpl';
import assetGridItemTemplate from './media_library.asset_grid_item.tpl';


const AssetItem = AbstractItem.extend({
    
    className: 'media-library-asset media-library-item',
    
    myEvents: {
      'click .action-expand-asset': 'expandAsset'
    },
    
    initialize: function(options){
      if (options.assetDisplayState === 'list') {
        this.template = assetListItemTemplate;
      } else {
        this.template = assetGridItemTemplate;
      }
      this.showSelectionOverlay = options.showSelectionOverlay;
      this._initializeBaseListeners();
      this.on('rendered', function(){
        var me = this;
        window.setTimeout(function(){
          me.loadThumbnail();
        }, 0);
      });
      if(options.allowDragging && options.dragHelperFn){
        this._bindDragging(options.dragHelperFn);
      }
      this.events = _extend({}, this.events, this.myEvents);
    },
    
    render: function() {
      this.thumbnailLoaded = false;
      this.$el.html(this.template({
        model: this.model,
        humanDisplayableAssetType: getDisplayNameForAssetType(this.model.get('assetType')),
        lastModifiedAtFormatted: defaultDatetimeFormat(this.model.getLastModifiedAt(), { includeTime:true }),
        showSelectionOverlay: this.showSelectionOverlay
      }));
      if (!this.showSelectionOverlay) {
        this.$('.thumbnail-wrapper').tipsy({
          title: 'tipsy',
          gravity: 'n'
        });
      }
      this.delegateEvents();
      this.trigger('rendered');
      return this;
    },
    
    expandAsset: function(e){
      e.stopPropagation();
      this.trigger('expand', this.model);
    },
    
    isScrolledIntoView: function() {
      var el = this.$el.get(0);
      var elemTop = el.getBoundingClientRect().top;
      var elemBottom = el.getBoundingClientRect().bottom;
      var isVisible = (elemTop >= 0) && (elemTop <= $(window).height());
      return isVisible;
    },
    
    loadThumbnail: function(){
      if(this.model.isPDF() || this.model.isOther() || this.model.isPPT() || this.model.isHtmlPackage()){
        return;
      }
      if(!this.thumbnailLoaded && this.isScrolledIntoView()){
        var $thumbnail = $('<img class="thumbnail-img" />');
        $thumbnail.attr('src', this.model.get('thumbnail'));
        this.$('.thumbnail-wrapper').append($thumbnail);
        this.thumbnailLoaded = true;
      }
    }
    
  });
  
export default AssetItem;
